import ReactGA from 'react-ga4';
import { ANALYTICS_CONFIG } from '@/constants/analytics';
import type { AnalyticsUserContext } from '@/types/analytics';

class AnalyticsService {
  private isInitialized = false;

  init(measurementId: string) {
    if (this.isInitialized || !ANALYTICS_CONFIG.ENABLED) return;
    ReactGA.initialize(measurementId, {
      gaOptions: { siteSpeedSampleRate: ANALYTICS_CONFIG.SITE_SPEED_SAMPLE_RATE }
    });
    this.isInitialized = true;
  }

  setUserId(userId?: string) {
    if (!this.isInitialized || !userId || !ANALYTICS_CONFIG.ENABLED) return;
    ReactGA.set({ user_id: userId });
  }

  trackPageView(path: string, userInfo?: AnalyticsUserContext) {
    if (!this.isInitialized || !ANALYTICS_CONFIG.ENABLED) return;
    if (userInfo?.userId && userInfo.userId !== 'default') {
      this.setUserId(userInfo.userId);
    }
    ReactGA.send({ hitType: 'pageview', page: path, ...userInfo });
  }

  trackBusinessEvent(event: string, context: Record<string, any>) {
    if (!this.isInitialized || !ANALYTICS_CONFIG.ENABLED) return;
    ReactGA.event({ category: 'business', action: event, ...context });
  }
}

export const analyticsService = new AnalyticsService(); 